import PaymentOptionsEnum from '../enums/payment-options';

/**
 * Get the first enabled payment option
 * @param {Array} paymentOptions - Payment options
 * @returns {string} - Payment option
 */
export default function getPaymentOption(paymentOptions) {
  if (!paymentOptions || paymentOptions.length === 0) {
    return {
      type: PaymentOptionsEnum.FULL,
    };
  }

  const firstEnabledOption = paymentOptions.find(option => option.enabled);

  if (firstEnabledOption) {
    return firstEnabledOption;
  }

  return {
    type: PaymentOptionsEnum.FULL,
  };
}
